__turbopack_context__.v({
  "addMoreText": "file-upload-module__BjaF6q__addMoreText",
  "container": "file-upload-module__BjaF6q__container",
  "dragging": "file-upload-module__BjaF6q__dragging",
  "dropzone": "file-upload-module__BjaF6q__dropzone",
  "dropzoneContent": "file-upload-module__BjaF6q__dropzoneContent",
  "dropzoneSubtext": "file-upload-module__BjaF6q__dropzoneSubtext",
  "dropzoneText": "file-upload-module__BjaF6q__dropzoneText",
  "error": "file-upload-module__BjaF6q__error",
  "errorText": "file-upload-module__BjaF6q__errorText",
  "fileDetails": "file-upload-module__BjaF6q__fileDetails",
  "fileIcon": "file-upload-module__BjaF6q__fileIcon",
  "fileInfo": "file-upload-module__BjaF6q__fileInfo",
  "fileItem": "file-upload-module__BjaF6q__fileItem",
  "fileList": "file-upload-module__BjaF6q__fileList",
  "fileName": "file-upload-module__BjaF6q__fileName",
  "fileSize": "file-upload-module__BjaF6q__fileSize",
  "floatingLabel": "file-upload-module__BjaF6q__floatingLabel",
  "hasFiles": "file-upload-module__BjaF6q__hasFiles",
  "hiddenInput": "file-upload-module__BjaF6q__hiddenInput",
  "label": "file-upload-module__BjaF6q__label",
  "optional": "file-upload-module__BjaF6q__optional",
  "removeButton": "file-upload-module__BjaF6q__removeButton",
  "toast": "file-upload-module__BjaF6q__toast",
  "toastClose": "file-upload-module__BjaF6q__toastClose",
  "toastContainer": "file-upload-module__BjaF6q__toastContainer",
  "toastContent": "file-upload-module__BjaF6q__toastContent",
  "toastIcon": "file-upload-module__BjaF6q__toastIcon",
  "toastItem": "file-upload-module__BjaF6q__toastItem",
  "toastList": "file-upload-module__BjaF6q__toastList",
  "toastMessage": "file-upload-module__BjaF6q__toastMessage",
  "toastTitle": "file-upload-module__BjaF6q__toastTitle",
  "toastViewport": "file-upload-module__BjaF6q__toastViewport",
  "uploadIcon": "file-upload-module__BjaF6q__uploadIcon",
});
